<template>
  <v-container fluid class="pa-0 brigadas">
    <v-container class="mb-15">
      <v-breadcrumbs class="px-0 breadcrumbs" :items="route" divider="/"></v-breadcrumbs>
      <h2 class=" pl-2">{{ $t("brigadas.title") }}</h2>
      <v-row class="pt-10 list-wrapper">
        <div id="pageContainer">
          <div id="viewer" class="pdfViewer"></div>
        </div>
      </v-row>
    </v-container>
  </v-container>
</template>
<script>
import $ from "jquery";
import pdfjsLib from "pdfjs-dist/build/pdf";
import { PDFViewer } from "pdfjs-dist/web/pdf_viewer";
import "pdfjs-dist/web/pdf_viewer.css";

pdfjsLib.GlobalWorkerOptions.workerSrc =
  "https://cdn.jsdelivr.net/npm/pdfjs-dist@2.0.489/build/pdf.worker.min.js";

export default {
  name: "Brigada",
  data: () => ({
    pdf: null,
    route: [
      {
        text: "Transparencia",
        disabled: false,
        to: "/transparencia"
      },
      {
        text: "Brigadas de Seguridad",
        disabled: true,
        to: "/transparencia/brigadas-de-seguridad"
      }
    ]
  }),
  //{v-container, v-row, v-col, v-data-table}
  methods: {
    loadPdf: function() {
      const publicPath = $(location).attr("origin") + "/archivos/brigadas/";
      const files = [];
      $.getJSON(publicPath, data => {
        data.map(file => {
          if (!file.match("index.php")) files.push(publicPath + file);
        });
        // console.warn(files[0]);
        // this.pdf = files[0];
        this.getPdf(files[0]);
      });
    },
    async getPdf(path) {
      let container = document.getElementById("pageContainer");
      let pdfViewer = new PDFViewer({ container: container });
      pdfjsLib.getDocument(path).then(pdf => {
        pdfViewer.setDocument(pdf);
        $(".textLayer").remove();
      });
    }
  },
  mounted: function() {
    this.loadPdf();
    $(".v-breadcrumbs__item--disabled:first").removeClass("v-breadcrumbs__item--disabled");
  }
};
</script>
<style lang="scss" scoped>
.brigadas {
  margin-top: 150px;
}
.breadcrumbs {
  position: absolute;
  margin-top: -60px !important;
}

@media (max-width: 960px) {
  .breadcrumbs {
    position: absolute;
    margin-top: -40px !important;
  }
  .brigadas {
    margin-top: 75px;
  }
}
</style>
<style lang="scss">
.brigadas {
  position: relative;
  #pageContainer {
    position: relative;
    margin: auto;
    width: 90%;
  }

  div.page {
    width: 100% !important;
    height: auto !important;
    // height: 70vh !important;
    * {
      width: 100% !important;
      height: auto !important;
    }
    .textLayer {
      display: none !important;
    }
  }
}
</style>
